import {mapOutputToTemplate} from "../../../helpers/mapOutputToTemplate"
import {getCalculation} from "../../calculation"
import initialState from "./initialState"

// SELECTORS
export const getCalculationOutput = (state) => getCalculation(state).output

// 1
export const getCalculationOutputMapper = (state) => (template) =>
  mapOutputToTemplate(getCalculationOutput(state), template)

// REDUCER
export default (state = initialState) => state
